import { getDefaultExportFromCjs as o } from "../../_virtual/_commonjsHelpers.js";
import { _ as s } from "./_baseKeys.js";
import { _ as e } from "./_getTag.js";
import { i as p } from "./isArguments.js";
import { i as f } from "./isArray.js";
import { i as m } from "./isArrayLike.js";
import { i as a } from "./isBuffer.js";
import { _ as n } from "./_isPrototype.js";
import { i as y } from "./isTypedArray.js";
var g = s, _ = e, c = p, A = f, b = m, T = a, j = n, E = y, P = "[object Map]", h = "[object Set]", d = Object.prototype, u = d.hasOwnProperty;
function x(r) {
  if (r == null)
    return !0;
  if (b(r) && (A(r) || typeof r == "string" || typeof r.splice == "function" || T(r) || E(r) || c(r)))
    return !r.length;
  var t = _(r);
  if (t == P || t == h)
    return !r.size;
  if (j(r))
    return !g(r).length;
  for (var i in r)
    if (u.call(r, i))
      return !1;
  return !0;
}
var O = x;
const M = /* @__PURE__ */ o(O);
export {
  M as default
};
//# sourceMappingURL=isEmpty.js.map
